import * as firebase from "firebase";
import 'firebase/firestore'
import {firebaseConfig} from "@/plugins/firebase";

// Get a Firestore instance
export const fire =  firebase
    .initializeApp(firebaseConfig);

export const db = fire.firestore();


// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
const {  GeoPoint, TimeStamp } = firebase.firestore;
export {  GeoPoint, TimeStamp }

